import React from "react";
import ModalFiltering from "./FormElements/ModalFiltering";
import Button from "./FormElements/Button";
import IconClose from "../Resources/svg/Icons/IconClose";

const ModalMaintenence = ({openModal, setOpenModal}: any) => {
  return (
    <ModalFiltering
      className={`modal-result is-midle watchlist ${openModal && "is-open"}`}
    >
      <div
        className="modal-filtering__close"
        onClick={() => setOpenModal(false)}
      >
        <IconClose />
      </div>
      <h2 className="modal-result__title">¡Lo sentimos!</h2>

      <div className="modal-result__desc">
        Actualmente estamos trabajando para mejorar nuestra plataforma. Durante
        este tiempo, el acceso para tu perfil está restringido. Te
        agradecemos por tu paciencia y comprensión. ¡Volveremos en breve!
      </div>

      <div className="actions">
        <Button
          className={`actions__continue`}
          onClick={() => setOpenModal(false)}
        >
          Entendido
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default ModalMaintenence;
